/**
 * UMA Resource Compiler
 *
 * Generates UMA (User-Managed Access) resource definitions from
 * DomainDefinition for registration with Keycloak.
 */

import type {
  AuthzConfig,
  ResourceDefinition,
} from "../schema/domain-definition";
import type { UmaResourceDefinition } from "../runtime/domain-runtime";

/**
 * Compile UMA resource definitions for Keycloak registration.
 *
 * Only resources with non-public visibility or ownerManagedAccess
 * produce UMA resource definitions.
 */
export function compileUmaResources(
  resources: Record<string, ResourceDefinition>,
  authz: AuthzConfig
): UmaResourceDefinition[] {
  const umaResources: UmaResourceDefinition[] = [];

  for (const [key, resource] of Object.entries(resources)) {
    // Public resources don't need UMA registration
    if (resource.authz.visibility === "public") continue;

    const scopes = resource.authz.scopes ?? [];

    umaResources.push({
      name: key,
      displayName: `${key} resource`,
      uri: resource.fetch.urlTemplate,
      type: resource.type,
      scopes,
      ownerManagedAccess: resource.authz.ownerManagedAccess ?? false,
      attributes: {
        visibility: [resource.authz.visibility],
        ...(resource.authz.roles
          ? { requiredRoles: resource.authz.roles }
          : {}),
      },
    });
  }

  return umaResources;
}
